// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"38650d03651a84f0","170":"a3d5ced96ef821bd","521":"74454d4c87909dbe","777":"be0ff809929648ad","964":"22a737e5960f76ad"}[chunkId] + ".js";
};